import { Component, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { HeaderComponent } from './components/layout/header/header.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { PlatformShellComponent } from './components/layout/platform-shell/platform-shell.component';
import { AuthService } from './services/auth/auth';
import { PushNotificationService } from './services/push-notification';
import { VisitTrackingService } from './services/visit-tracking';
import { PhoneClaimModalComponent } from './components/shared/phone-claim-modal/phone-claim-modal.component';
import { ConfirmDialogComponent } from './components/shared/confirm-dialog/confirm-dialog.component';
import { ImpersonationBannerComponent } from './components/shared/impersonation-banner/impersonation-banner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, PlatformShellComponent, PhoneClaimModalComponent, ConfirmDialogComponent, ImpersonationBannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  title = 'Cargo';

  /** Страницы личного кабинета (data.layout = 'platform', с учётом data.layoutRoles) — в каркасе с боковым меню, без шапки и футера сайта. */
  platformLayout = false;

  constructor(
    private authService: AuthService,
    private pushService: PushNotificationService,
    private visitTracking: VisitTrackingService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Статистика посетителей: просмотры страниц и время на странице
    this.visitTracking.start();

    // При уже авторизованном пользователе подписываемся на push
    // В режиме «Войти как» пуш админа не привязываем к клиенту
    if (this.authService.isAuthenticated() && !this.authService.isImpersonating()) {
      this.pushService.subscribeAndRegister().catch(() => {});
    }

    // ResolveEnd приходит до создания страницы — каркас меняется раньше, и страница не создаётся дважды
    this.router.events.pipe(filter((e): e is ResolveEnd => e instanceof ResolveEnd)).subscribe(e => {
      let route: ActivatedRouteSnapshot | null = e.state.root;
      while (route?.firstChild) {
        route = route.firstChild;
      }
      // layoutRoles — каркас кабинета только для этих ролей, остальным страница в обычном виде сайта
      const roles: string[] | undefined = route?.data['layoutRoles'];
      this.platformLayout = route?.data['layout'] === 'platform'
        && (!roles || roles.includes(this.authService.getUser()?.role?.code ?? ''));
    });
  }
}
